var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DEEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53717 7.46521C8.80281 6.98634 8.74981 6.39361 8.40343 5.96963L6.99458 4.24513C6.74457 3.9391 6.28538 3.91617 6.0062 4.19576L4.62239 5.58163C3.60569 6.60144 3.99982 8.08742 4.63372 9.38623C6.05371 12.2957 7.99915 14.2379 10.6216 15.3832C11.9434 15.9604 13.404 16.4144 14.4207 15.3946L15.8045 14.0087C16.0837 13.7291 16.0608 13.2692 15.7552 13.0189L14.0333 11.6079C13.61 11.261 13.0181 11.2079 12.54 11.474L10.8824 12.3962C9.3011 11.2917 8.74193 10.7414 7.61633 9.12519L8.53717 7.46521Z",
    stroke: "#0065FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePhone);
export default __webpack_public_path__ + "static/media/home-phone.04b01bfa6dcdfd231a57448bba99432d.svg";
export { ForwardRef as ReactComponent };